import React from 'react';
import StarRating from '../../../components/shared/StarRating';
import { STATS } from '../../../config/socialProof';

/**
 * StatsBar Component
 * Displays key stats in the hero section (businesses, rating, uptime)
 */
const StatsBar = () => {
    const stats = [
        {
            value: STATS.activeBusinesses.value,
            label: STATS.activeBusinesses.label,
        },
        {
            component: (
                <StarRating
                    rating={STATS.capterra.rating}
                    reviews={STATS.capterra.reviews}
                    platform={STATS.capterra.platform}
                    size="sm"
                />
            ),
        },
        {
            value: STATS.uptime.value,
            label: STATS.uptime.label,
        },
    ];

    return (
        <div
            style={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: '32px',
                justifyContent: 'center',
                alignItems: 'center',
                padding: '24px 0',
            }}
        >
            {stats.map((stat, index) => (
                <div
                    key={index}
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        gap: '4px',
                    }}
                >
                    {stat.component || (
                        <>
                            <div
                                style={{
                                    fontSize: '28px',
                                    fontWeight: 700,
                                    color: '#FFFFFF',
                                    lineHeight: 1,
                                }}
                            >
                                {stat.value}
                            </div>
                            <div
                                style={{
                                    fontSize: '14px',
                                    fontWeight: 400,
                                    color: 'rgba(255, 255, 255, 0.9)',
                                    lineHeight: 1,
                                }}
                            >
                                {stat.label}
                            </div>
                        </>
                    )}
                </div>
            ))}
        </div>
    );
};

export default StatsBar;
